import React from "react";

const TechnicalSkills = () => {

  return (
    <div
      name="TechnicalSkills"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-screen"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Technical Skills
          </p>
          <p className="py-6">Technologies that I've worked on</p>
        </div>
        <br />
        <br />

        <div>
          <p className="text-2xl font-semibold">
            Programming Languages:
            
          </p>
          <p className="text-xl"> 
          Java, C++, Python, C, C#, JavaScript, TypeScript HTML, CSS, Kotlin
          </p>
          <br />
        </div>
        
        <div>
          <p className="text-2xl font-semibold">
            Frameworks:
          </p>
          <p className="text-xl"> 
          Java Spring, React, Angular, Node, Express, Python Flask, Django, ASP.NET
          </p>
          <br />
        </div>

        <div>
          <p className="text-2xl font-semibold">
            Databases:
          </p>
          <p className="text-xl"> 
          MySQL, PostgreSQL, MongoDB, Firebase, SQL Server, NoSQL
          </p>
          <br />
        </div>

        <div>
          <p className="text-2xl font-semibold">
            Web Technologies:
          </p>
          <p className="text-xl"> 
          Bootstrap, OAuth, JWT, SOAP, REST, JSON, XML, Microservices, JUnit, JEST, Cypress
          </p>
          <br />
        </div>

        <div>
          <p className="text-2xl font-semibold">
            Tools:
          </p>
          <p className="text-xl"> 
          VSCode, IntelliJIDEA, Eclipse, SQL workbench, Git, GitHub, Docker
          </p>
          <br />
        </div>

        

        
      </div>
    </div>
  );
};

export default TechnicalSkills;
